import { useParams } from 'react-router-dom';

import { useGetSpacesByIdQuery } from '@client/api';

import { CommonAreasListCard } from '../../../../components/common-areas-list-card/common-areas-list-card.component';
import { SpaceInformationCard } from '../components/space-information/space-information-card.component';

export const SpaceView = () => {
  const { spaceId } = useParams<{ spaceId: string }>();

  const { data: space, isFetching } = useGetSpacesByIdQuery(
    {
      id: spaceId ?? '',
    },
    { skip: !spaceId },
  );

  return (
    <div className="relative md:flex">
      <div className="w-full mb-2 space-y-2">
        <SpaceInformationCard space={space} isFetching={isFetching} />

        <CommonAreasListCard />
      </div>
    </div>
  );
};
